import { Auth } from 'aws-amplify';
import { ConfirmSignIn } from 'aws-amplify-react';
import React from 'react';
import Button from '../Button';
import ContainerDefault from '../Container';
import Form from '../Form';
import Row from '../Row';
import Section from '../Section';
import Explanation from './Explanation';

const Container = ContainerDefault.extend`
    max-width: 20rem;
    position: relative;
`;

const help = {
    head: 'Two factor authentication',
    text:
        'We take security seriously. To make sure that only you can access your account we sent a code to your mobile phone by SMS. Please type the code into the text box on the left side.'
};

export default class CustomConfirmSignIn extends ConfirmSignIn {
    constructor(props) {
        super(props);
        this.onKeyPress = this.onKeyPress.bind(this);
    }

    public signUp() {
        const { given_name, family_name, password, email, phone_number } = this.inputs;
        Auth.signUp({ username: email, password, attributes: { given_name, family_name, phone_number } })
            .then(() => this.changeState('confirmSignUp', email))
            .catch(err => this.error(err));
    }

    private onKeyPress(e) {
        if (e.key === 'Enter') {
            this.confirm();
        }
    }

    public render() {
        const { authState } = this.props;

        if (authState !== 'confirmSignIn') {
            return null;
        }

        return (
            <Section>
                <Container>
                    <Form>
                        <h3>Confirm Sign In</h3>
                        <input
                            autoFocus
                            placeholder="Code"
                            key="code"
                            name="code"
                            autoComplete="off"
                            onChange={this.handleInputChange}
                            onKeyPress={this.onKeyPress}
                        />
                        <Button onClick={this.confirm}>Confirm</Button>
                    </Form>
                    <Row>
                        <Button normal onClick={() => this.changeState('signIn', undefined)}>
                            Back to Sign In
                        </Button>
                    </Row>
                    <Explanation help={help} />
                </Container>
            </Section>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/cognito/CustomConfirmSignIn.tsx